import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { EDIT_MODE } from "@/components/OverrideLayer";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export default function CustomPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(undefined);

  useEffect(() => {
    axios.get(`${API}/pages`).then((r) => setPage(r.data.find((p) => p.slug === slug) || null)).catch(() => setPage(null));
  }, [slug]);

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="custom-page">
      <Header />
      <main className="flex-1 pt-24">
        <section className="py-16">
          <div className="container mx-auto px-4 max-w-5xl">
            {page === null ? (
              <h1 className="text-4xl font-nouvel font-bold" data-testid="custom-page-missing">Seite nicht gefunden</h1>
            ) : (
              <>
                <h1 className="text-4xl sm:text-5xl font-nouvel font-bold text-black mb-6" data-testid="custom-page-title">{page?.title || ""}</h1>
                <div className="w-16 h-1 bg-[#EFDF00] mb-8" />
                <p className={`font-read text-[#656666] ${EDIT_MODE ? "" : "hidden"}`} data-testid="custom-page-placeholder">
                  Neue Seite: Diesen Text anklicken und über „+ Element“ Überschriften, Texte, Bilder, Knöpfe oder Reiter hinzufügen.
                </p>
              </>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
